<app-loading [hidden]="!banderaCargando"></app-loading>
<div class="tercero-informacion" *ngIf="!banderaCargando && acceso">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-4">
      <div
        class="tercero-informacion-lista-restrictivas"
        *ngIf="listasRestrictivas && !listasRestrictivas.error"
      >
        <div>
          <img src="../../../../assets/icons/perfil-crezcamos/ico-relacion-listas.svg" alt="icono-relacion-listas" title="icono-relacion-listas"/>
          <h3>{{ "PERFILCREZCAMOS.LBL_LISTARESTRICTIVAS" | translate }}</h3>
          <p>
            {{
              (listasRestrictivas.listas.length > 0
                ? "PERFILCREZCAMOS.LBL_CONALERTA"
                : "PERFILCREZCAMOS.LBL_SINALERTA"
              ) | translate
            }}
          </p>
        </div>
        <p>
          {{
            (listasRestrictivas.listas.length > 0
              ? "PERFILCREZCAMOS.LBL_PERTENECELISTARESTRICTIVA"
              : "PERFILCREZCAMOS.LBL_NOPERTENECELISTARESTRICTIVA"
            ) | translate
          }}
        </p>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-8">
      <div
        class="tercero-informacion-datos"
        *ngIf="informacionNotaInterna && informacionTerceroAdicional"
      >
        <div class="grid">
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_NOTA" | translate }}
              <strong>{{
                informacionNotaInterna &&
                informacionNotaInterna.nota &&
                informacionNotaInterna.nota.notaInterna !== null
                  ? informacionNotaInterna.nota.notaInterna
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_CICLO" | translate }}
              <strong>{{
                informacionNotaInterna &&
                informacionNotaInterna.nota &&
                informacionNotaInterna.nota.ciclo !== null
                  ? informacionNotaInterna.nota.ciclo
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_MORAACTUAL" | translate }}
              <strong>{{
                informacionNotaInterna &&
                informacionNotaInterna.nota &&
                informacionNotaInterna.nota.diasMora !== null
                  ? informacionNotaInterna.nota.diasMora
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_MONTOMASALTO" | translate }}
              <strong>{{
                informacionTerceroAdicional &&
                informacionTerceroAdicional.montoMasAlto !== null
                  ? (informacionTerceroAdicional.montoMasAlto / 1000 | dinero)
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_RESPALDOS" | translate }}
              <strong>{{
                informacionTerceroAdicional &&
                informacionTerceroAdicional.respaldos !== null
                  ? (informacionTerceroAdicional.respaldos / 1000 | dinero)
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <p class="tercero-informacion-dato">
              {{ "PERFILCREZCAMOS.LBL_ULTIMAGARANTIA" | translate }}
              <strong>{{
                informacionTerceroAdicional &&
                informacionTerceroAdicional.ultimaGarantia !== null
                  ? informacionTerceroAdicional.ultimaGarantia
                  : ("-" | translate)
              }}</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="informacionTercero">
    <div class="grid">
      <div class="col-12">
        <h3 class="tercero-informacion-titulo">{{ "PERFILCREZCAMOS.LBL_FOTOS" | translate }}</h3>
      </div>
    </div>

    <ng-container *ngIf="listadoAdjuntos && listadoAdjuntos.length > 0; else noAdjuntos">
      <app-listado-adjuntos [listadoAdjuntos]="listadoAdjuntos"></app-listado-adjuntos>
    </ng-container>
  
    <ng-template #noAdjuntos>
      <div class="no-hay-informacion">
        <label>{{ "PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR" | translate }}</label>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="!informacionTercero && !listasRestrictivas && !informacionNotaInterna && !informacionTerceroAdicional">
    <div class="no-hay-informacion">
      <label>{{ "PERFILCREZCAMOS.LBL_NOHAYINFORMACIONPARAMOSTRAR" | translate }}</label>
    </div>
  </ng-container>
</div>

<div class="no-hay-informacion" *ngIf="!acceso">
  <label>{{ "PERFILCREZCAMOS.LBL_SINACCESO" | translate }}</label>
</div>